import React, {useContext, useState, useEffect} from 'react';
import {AppContext} from '../../context/app/appContext';
import {useHistory} from "react-router-dom";
import {Confirm, Icon, Popup} from "semantic-ui-react";

const TopBarComponent = () => {

    const history = useHistory();

    const currentUser = {
        firstName: 'Amy',
        avatar: 'avatar-female',
    };

    const [showConfirmLogoutModal, setShowConfirmLogoutModal] = useState(false);
    const [username, setUsername] = useState('')

    const appContext = useContext(AppContext);

    useEffect(() => {
        (async function onRefresh(){
            console.log("========== This was called")
            const accessToken = localStorage.getItem('accessToken');
            console.log(accessToken)
            if(accessToken){
                if(!appContext.user.email.length){
                    console.log("hereeeeeeeeeeeeeeeee")
                    const user = JSON.parse(localStorage.getItem('user'))
                    const organization = JSON.parse(localStorage.getItem('organization'))
                    console.info({user})
                    console.info({organization})
                    await appContext.setAuthorizedUser(user);
                    await appContext.setOrganizationPartialInfo(organization);
                }
            }
        })();
    }, [])

    useEffect(() => {
        setUsername(appContext.user.firstName + " " + appContext.user.lastName)
    }, [appContext.user])

    // const username = appContext.user.firstName + " " + appContext.user.lastName; //currentUser.firstName;
    const avatar = `${process.env.PUBLIC_URL}/assets/images/avatar/${currentUser.avatar}.png`;

    const handleLogout = () => {
        setShowConfirmLogoutModal(true);
    }
    const handleCancelLogout = () => {
        setShowConfirmLogoutModal(false);
    }

    const handleConfirmLogout = async () => {
        appContext.logOut();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('email');
        localStorage.removeItem('user');
        localStorage.removeItem('organization');
        setShowConfirmLogoutModal(false);
        history.push(`/login`);
    }

    return (
        // <div id="top-bar"  style={{width: '100%', height: '100%', backgroundColor: 'rgba(251, 251, 251, 1)'}}>
        <div id="top-bar"  style={{width: '100%', height: '100%', backgroundColor: 'transparent'}}>

            {(appContext && appContext.organization && appContext.organization.pendingVerification) && (<div className="ui icon warning message">
                <i aria-hidden="true" className="circle notched loading icon"/>
                <div className="content">
                    <div className="header">Verifying organization</div>
                    <p>We are verifying organization information. This may take a while. Please check back later.</p>
                </div>
            </div>)}

            {/* <div className="ui two column grid">
                <div className="column">
                    <h1 id="logo">Perkfix</h1>
                    <h2 id="company-name">People Ops</h2>
                </div>
                <div className="column right aligned">
                    <div id="user-actions">

                        <div className="notifications">
                            <i aria-hidden="true" className="mail icon"/>
                            <p className="ui orange circular label notification-count">!</p>
                        </div>

                        <button className="ui button primary logout-btn" onClick={handleLogout}>Log Out</button>

                        <div className="avatar">
                            <img
                                src={avatar}
                                alt="user"/>
                        </div>

                        <p className="user-greeting">{`Welcome back, ${username}`}</p>

                    </div>
                </div>
            </div> */}

            {/* <div style={{width: '100%', height: '10vh'}}> */}
            <div>
                <div className="ui two column grid">
                <div className="column">
                    {/* <h6 id="logo">Perkfix</h6>
                    <h3 id="company-name" style={{color: 'black'}}>People Ops</h3> */}
                </div>
                <div className="column right aligned" style={{}}>
                    <div id="user-actions" style={{display: 'flex'}}>
                        <div className="user-greeting" style={{color: 'black', fontStyle: 'SFProDisplay-Semibold'}}>{`Welcome back, ${username}`}</div>
                        {/* <div className="notifications">
                            <i aria-hidden="true" className="mail icon"/>
                            <p className="ui orange circular label notification-count">!</p>
                        </div> */}

                        {/* <button className="ui button primary logout-btn" onClick={handleLogout}>Log Out</button> */}
                        <Popup content='Log Out' style={{paddingLeft: 5}} trigger={
                            <Icon name="sign out" size="big" color='grey' onClick={handleLogout} 
                                style={{alignSelf: 'center', marginLeft: 0}} />
                        }/>
                        

                        <div className="avatar" style={{}}>
                            {/* <img
                                src={avatar}
                                alt="user"/> */}
                                <div style={{backgroundColor: 'grey', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontStyle: 'SFProText-Bold', fontWeight: 900, fontSize: 16}}>{appContext.user.firstName.charAt(0) + appContext.user.lastName.charAt(0)}</div>
                        </div>

                        

                    </div>
                </div>
            </div>
            </div>

            <Confirm dimmer='blurring' open={showConfirmLogoutModal}
                     content='Are you sure you want to logout?'
                     cancelButton='No'
                     confirmButton="Yes"
                     onCancel={handleCancelLogout} onConfirm={handleConfirmLogout}/>
        </div>
    );
};

export const TopBar = TopBarComponent;
